import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
@Component({
  selector: 'app-special-interest-section',
  templateUrl: './special-interest-section.component.html',
  styleUrls: ['./special-interest-section.component.scss'],
  providers: [],
})
export class SpecialInterestSectionComponent implements OnInit {
  // sailingImageUrl = `${environment.cdnBaseURL}public/images/sailing_menu_new.avif`;
  // romanceImageUrl = `${environment.cdnBaseURL}public/images/romance_menu_new.avif`;
  // divingImageUrl = `${environment.cdnBaseURL}public/images/diving_menu_new.avif`;
  //natureImageUrl = `${environment.cdnBaseURL}public/images/nature_menu_new.avif`;
  //cultureImageUrl = `${environment.cdnBaseURL}public/images/culture_menu_new.avif`;
  //sustainableImageUrl = `${environment.cdnBaseURL}public/images/sustainable_menu_new.avif`;
  // fishingImageUrl = `${environment.cdnBaseURL}public/images/fishing_menu_new.avif`;
  sailingImage240 = `${environment.cdnBaseURL}public/images/sailing_menu_new_240.avif`;
  sailingImage480 = `${environment.cdnBaseURL}public/images/sailing_menu_new_480.avif`;
  sailingImage720 = `${environment.cdnBaseURL}public/images/sailing_menu_new_720.avif`;
  romanceImage240 = `${environment.cdnBaseURL}public/images/romance_menu_new_240.avif`;
  romanceImage480 = `${environment.cdnBaseURL}public/images/romance_menu_new_480.avif`;
  romanceImage720 = `${environment.cdnBaseURL}public/images/romance_menu_new_720.avif`;
  divingImage240 = `${environment.cdnBaseURL}public/images/diving_menu_new_240.avif`;
  divingImage480 = `${environment.cdnBaseURL}public/images/diving_menu_new_480.avif`;
  divingImage720 = `${environment.cdnBaseURL}public/images/diving_menu_new_720.avif`;
  natureImage240 = `${environment.cdnBaseURL}public/images/nature_menu_new_240.avif`;
  natureImage480 = `${environment.cdnBaseURL}public/images/nature_menu_new_480.avif`;
  natureImage720 = `${environment.cdnBaseURL}public/images/nature_menu_new_720.avif`;
  cultureImage240 = `${environment.cdnBaseURL}public/images/culture_menu_new_240.avif`;
  cultureImage480 = `${environment.cdnBaseURL}public/images/culture_menu_new_480.avif`;
  cultureImage720 = `${environment.cdnBaseURL}public/images/culture_menu_new_720.avif`;
  sustainableImage240 = `${environment.cdnBaseURL}public/images/sustainable_menu_240.avif`;
  sustainableImage480 = `${environment.cdnBaseURL}public/images/sustainable_menu_480.avif`;
  sustainableImage720 = `${environment.cdnBaseURL}public/images/sustainable_menu_720.avif`;
  fishingImage240 = `${environment.cdnBaseURL}public/images/fishing_menu_new_240.avif`;
  fishingImage480 = `${environment.cdnBaseURL}public/images/fishing_menu_new_480.avif`;
  fishingImage720 = `${environment.cdnBaseURL}public/images/fishing_menu_new_720.avif`;
  navigateTo(path: string): void {
    this.router.navigate([`/special_interest/${path}`]);
  }

  //constructor
  constructor(public routes: ActivatedRoute, public router: Router) {}

  ngOnInit() {}
}
